import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { USER_MGMT_CNST, PROJECT_CONSTANTS } from '../../constants/proj.cnst';
import { UM_TABLE_CNST } from '../../constants/table.cnst';
import { Config, Path } from '../../enums';
import { AuthenticationService } from '../../modules/authentication/services/authentication.service';
import { isNullOrUndefined } from '../../modules/shared/common-utils';
import { InitService } from '../../parsers/init.service';
import { AppStateService } from '../../services/app-state.service';
import { CommonService } from '../../services/common.service';
import { DataService } from '../../services/data.service';
import { EnvService } from '../../services/env.service';
import { HttpService } from '../../services/http.service';
import { UtilsService } from '../../services/utils.service';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthorizationModule } from '../../modules/authorization';
import { SkeletonModule } from '../../modules/shared/components/skeleton/skeleton.module';
import { ImportsModule } from '../../modules/imports/imports';
import { TableModule } from 'primeng/table';
import { PrimengTableComponent } from '../../modules/shared/components/primeng-table/primeng-table.component';
import { PrimengBreadcrumbComponent } from '../../modules/shared/components/primeng-breadcrumb/primeng-breadcrumb.component';
import { UsersListComponent } from './components/users-list/users-list.component';
import { TablerIconComponent } from 'angular-tabler-icons';
import { PermissionsService } from '../../modules/shared/directives/permissions.service';
@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  standalone: true,
  imports : [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    AuthorizationModule,
    SkeletonModule,
    ImportsModule,
    TableModule,
    CommonModule,
    PrimengBreadcrumbComponent,
    RouterModule,
    UsersListComponent,
    TablerIconComponent
  ]
})
export class UserComponent implements OnInit, OnDestroy {
  tableConfig: any = {}
  tableData: any = [];

  showSearchCustomers = true;
  loading: boolean = true;
  updateInProcess: boolean = false;
  addConfig: any;
  isEditPermission: boolean = false;

  loadMoreRecordsOnScroll: boolean = true;
  fetchedRecordsCount: number = 0;
  currentPage: number = 0;
  currentOffset: number = 0;

  //*Infinite scrolling related variables
  scrollDistance!: number;
  throttle!: number;
  isScrollOnWindow!: boolean;

  subscriptions: Subscription[] = [];
  wasPageScrolled!: boolean;
  loggedInUserFlag: boolean = false;
  currentResponseLength!: number;
  customerListData: any;
  isCustomer: any;
  customerSelected: any;
  userListData: any[] = [];
  userSelected: any[] = [];
  constructor(
    private commonSrv: CommonService,
    private httpSrv: HttpService,
    private dataSrv: DataService,
    private utilSrv: UtilsService,
    private appStateSrv: AppStateService,
    private authStateSrv: AuthenticationService,
    private initSrv: InitService,
    private envService: EnvService,
    private datePipe: DatePipe,
    private router: Router,
    private messageService: MessageService,
    private permissionsService: PermissionsService,
  ) { }

  ngOnInit() {
    this.isEditPermission = this.permissionsService.hasEditPermission(
      UM_TABLE_CNST.RESOURCES_LIST.user,
      PROJECT_CONSTANTS.USERMGMT_APP_NAME
    );
    // let metaInfo = this.appStateSrv.getUserMetaInfo();
    let  metaInfo : any =  localStorage.getItem("metaInfo")
    metaInfo = JSON.parse(metaInfo);
    this.isCustomer = !!(metaInfo && (isNullOrUndefined(metaInfo['customerId']) || isNullOrUndefined(metaInfo['customerName'])))
    this.setTableConfig();
    this.setTableData();

    const operationRef = this.appStateSrv.operationRef.subscribe(
      (value: any) => {
        let { operation, postData } = value;

        if (operation === USER_MGMT_CNST.OPERATION_TYPES.USER.DELETE_USER) {
          this.deleteUser(postData)
        } else if (operation === USER_MGMT_CNST.OPERATION_TYPES.USER.EDIT_USER) {
          this.updateUser(postData);
        }
      }
    );

    this.wasPageScrolled = this.appStateSrv.getWasPageScrolled();

    const pageScrolledRef = this.appStateSrv.wasPageScrolledRef.subscribe((value: boolean) => {
      this.wasPageScrolled = value;
      if (this.loadMoreRecordsOnScroll) {
        if (this.customerSelected) {
          this.customerBasedUserList(this.customerSelected['customerId']);
        } else {
          this.setTableData();
        }
      }
    });

    this.subscriptions.push(operationRef);
    this.subscriptions.push(pageScrolledRef);
    this.initializeInfiniteScrollVariables();
    if (this.isCustomer) {
      this.setCustomerListData();
    }
    
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  initializeInfiniteScrollVariables() {
    let { SCROLL_DISTANCE, THROTTLE, SCROLL_ON_WINDOW } = USER_MGMT_CNST.INFINITE_SCROLL_OPTIONS;

    this.scrollDistance = SCROLL_DISTANCE;
    this.throttle = THROTTLE;
    this.isScrollOnWindow = SCROLL_ON_WINDOW;
  }

  addUserModal() {
    if (!this.isEditPermission) {
      return;
    }
    let { USER_MODULE_OPERATIONS } = USER_MGMT_CNST;
    this.router.navigate(['usermgmt', 'users', 'config'], {
      queryParams: {
        operation: USER_MODULE_OPERATIONS.ADD_USER
      }
    })
  }

  initializeAddUserConfig() {
    return this.initSrv.loadConfig({
      path: Path.ADD_USER_CONFIG_PATH,
      configType: Config.ADD_USER_CONFIG
    });
  }

  setTableConfig() {
    this.tableConfig = this.commonSrv.setTableConfig(!this.isCustomer ? USER_MGMT_CNST.LIST_NAME_MAPPING.USER_LIST : USER_MGMT_CNST.LIST_NAME_MAPPING.USER_CUSTOMER_LIST);
    this.tableConfig.hasInfiniteScroll = true;
  }

  setTableData() {

    let options = {
      'queryParams': {
        size: USER_MGMT_CNST.INFINITE_SCROLL_OPTIONS.INFINITE_SCROLL_LIMIT,
        offset: this.currentOffset
      }
    }

    this.loading = true;
    this.fetchUserList(options);
  }

  deleteUser(postdata: any) {
    if (!this.isEditPermission) {
      return;
    }
    this.httpSrv.makeDeleteApiCall('KEYCLOAK_DELETE_USER', this.envService.baseUrl, { uriParams: { userId: postdata.userId } }).subscribe({
      next: (res: any) => {
        this.resetVariables();
        this.setTableData();
        this.userListData = [];
        this.userSelected = [];
        (res.response) ? this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User deleted successfully' }) :
        this.messageService.add({ severity: 'error', summary: 'Error', detail: "Failed to delete the user" });
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: "Failed to delete the user" });
      }
    });
  }

  updateUser(postdata: any) {
    if (!this.isEditPermission) {
      return;
    }

    if (this.updateInProcess) return;

    this.updateInProcess = true;
    if (postdata['metaInfo']) {
      postdata['metaInfo']['status'] = postdata['metaInfo']['status'] === USER_MGMT_CNST.STATUS_TYPE_LIST.ACTIVE;
    }
    const { userId = '', operation, ...rest } = postdata;
    if(rest['metaInfo']) {
      rest['metaInfo']['userId'] = userId;
    }
    this.httpSrv.makePutApiCall('UPDATE_USER', rest, this.envService.baseUrl).subscribe({
      next: (res: any) => {
        this.updateInProcess = false;
        this.resetVariables();
        this.setTableData();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'User details updated successfully' });
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: "Failed to update user details" });
      }
    });
  }

  formatCustomerList(response: any) {
    let formattedCustomerList = [];

    for (let custId in response) {
      let customerInfo = response[custId];
      formattedCustomerList.push(customerInfo);
    }

    return formattedCustomerList;
  }

  handleTableScroll() {
    if (this.loadMoreRecordsOnScroll) {
      this.setTableData();
    }
  }

  setCustomerListData() {
   if(this.appStateSrv.getUserPermissions()?.['User Management']?.['resources'] && Object.keys(this.appStateSrv.getUserPermissions()?.['User Management']?.['resources']).includes("CUSTOMER")) {
    this.httpSrv.makeGetApiCall('GET_CUSTOMERS_LIST', this.envService.baseUrl).subscribe({
      next: (response: any) => {
        let customerListData = this.transformData(response);
        this.customerListData = this.dataSrv.addOptionsToTableData(customerListData, UM_TABLE_CNST.RESOURCES_LIST.customers);
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: "Failed to fetch customer list" });
      }
    });
   }
  }

  transformData(response: any) {
    if (!Array.isArray(response)) {
      return Object.values(response);
    } else {
      return response;
    }
  }

  onCustomerSelect(e: any) {
    if (!isNullOrUndefined(e)) {
      this.resetVariables();
      this.userSelected = [];
      this.userListData = [];
      this.customerBasedUserList(e.customerId)
    }
  }

  clearCustomerOptions() {
    this.resetVariables();
    this.setTableData();
  }

  resetVariables() {
    this.loadMoreRecordsOnScroll = true;
    this.currentPage = 0;
    this.currentOffset = 0;
    this.loggedInUserFlag = false;
    this.tableData = [];
  }
  
  customerBasedUserList(customerId: any) {
    let options = {
      'uriParams': {
        customerId: customerId
      },
      'queryParams': {
        size: USER_MGMT_CNST.INFINITE_SCROLL_OPTIONS.INFINITE_SCROLL_LIMIT,
        offset: this.currentOffset
      }
    }
    this.loading = true;
    this.fetchUserList(options);
  }

  fetchUserList(options: any) {
    this.loading = true;
    
    this.httpSrv.makeGetApiCall('GET_USER_LIST', this.envService.baseUrl, options).subscribe({
        next: (userList: any[]) => {
          userList = Array.isArray(userList) ? userList : userList['response'];
          userList = userList ? Object.keys(userList).map((userId: any) => {
            return {
                userId: userId,
                ...userList[userId]
            };
          }) : [];
          this.commonTableDataFormater(userList);
        },
        complete: () => { },
        error: () => {
          this.loading = false;
          this.tableData = [];
          this.messageService.add({ severity: 'error', summary: 'Error', detail: "Failed to fetch user list" });
        }
      })
  }

  commonTableDataFormater(userList: any) {

    if (userList?.length === 0) {
      this.loadMoreRecordsOnScroll = false;
    }

    this.currentResponseLength = userList?.length;
    let tableData: any = this.dataSrv.addOptionsToTableData(userList, UM_TABLE_CNST.RESOURCES_LIST.user);
    const userMap: any = {};
    const loggedInUserId = this.authStateSrv.getUserId();
    if (tableData.find((r: any) => r.userId === loggedInUserId)) {
      this.loggedInUserFlag = true;
    }
    // Filter the current user record
    tableData = tableData.filter((r: any) => r.userId !== loggedInUserId);

    tableData.forEach((record: any, i: any) => {

      let user = userMap[record.userId];
      const { applicationName, applicationId, roleName, roleId, module, ...rest } = record;

      const application = {
        applicationName,
        applicationId,
        roleName,
        roleId,
        module
      }

      if (!user) {
        user = { ...rest };
        user.applications = [application];
      } else {
        user.applications = [...user['applications'], application];
      }
      userMap[record.userId] = user;
    })

    this.tableData = [...this.tableData, ...Object.values(userMap)];

    let modifiedTableData = this.tableData.map((e: any) => {
      e['name'] = e['userName'];
      e['mobileNumber'] = this.utilSrv.formatMobileNumberForDisplay(e['mobileNumber']);
      e['online'] = this.formatOnlineStatus(e['online']);
      const moduleValues = this.getModuleValues(e['applicationRolesDetailsList']);
      e['moduleDisplayList'] = moduleValues;
      e['module'] = moduleValues.length ? moduleValues.join(', ') : '-';
      return e;
    });

    this.tableData = modifiedTableData;


    this.currentPage++;
    if (this.currentResponseLength === USER_MGMT_CNST.INFINITE_SCROLL_OPTIONS.INFINITE_SCROLL_LIMIT) {
      this.currentOffset += USER_MGMT_CNST.INFINITE_SCROLL_OPTIONS.INFINITE_SCROLL_LIMIT;
    }
    else {
      this.loadMoreRecordsOnScroll = false;
    }
    this.loading = false;
  }

  fetchUsers(text: any) {
    let optionsList = {
      'queryParams': {
        userName: text,
        ...((this.customerSelected) && { customerId: this.customerSelected['customerId'] }),
      }
    }

    this.httpSrv.makeGetApiCall('SEARCH_USERS', this.envService.baseUrl, optionsList).subscribe({
        next: (userList: any[]) => {
          userList = Array.isArray(userList) ? userList : userList['response'];
          this.userListData = userList;
        },
        complete: () => { },
        error: () => {
          this.loading = false;
          this.tableData = [];
          this.messageService.add({ severity: 'error', summary: 'Error', detail: "Failed to fetch users list" });
        }
      })
  }

  onUserSelect(e: any) {
    if (!isNullOrUndefined(e) && e.length > 0) {
      this.resetVariables();
      this.commonTableDataFormater(e);
    } else {
      this.clearCustomerOptions();
    }
  }

  onSelectAll() {
    this.userSelected = this.userListData;
    this.onUserSelect(this.userSelected);
  }

  clearUserOptions() {
    this.resetVariables();
    this.userListData = [];
    this.userSelected = [];
    if (this.customerSelected) {
      this.customerBasedUserList(this.customerSelected['customerId']);
    }
  }

  setOperationType(value : any) {
    this.appStateSrv.operationRef.next(value);
  }

  formatOnlineStatus(value: any): string {
    if (value === true || (typeof value === 'string' && value.toLowerCase() === 'online')) {
      return 'Online';
    }
    if (value === false || (typeof value === 'string' && value.toLowerCase() === 'offline')) {
      return 'Offline';
    }
    return '-';
  }

  getModuleValues(applicationRolesDetailsList: any): string[] {
    if (!Array.isArray(applicationRolesDetailsList)) {
      return [];
    }
    return applicationRolesDetailsList
      .map((item: any) => item?.module)
      .filter((moduleValue: any) => this.hasModuleValue(moduleValue))
      .map((moduleValue: any) => String(moduleValue).trim());
  }

  hasModuleValue(moduleValue: any): boolean {
    if (moduleValue === null || moduleValue === undefined) {
      return false;
    }
    const normalizedValue = String(moduleValue).trim();
    return normalizedValue !== '' && normalizedValue.toLowerCase() !== 'null';
  }

}
